import { create } from 'zustand';
import { Pipeline, SimplePipeline } from '../interfaces/Pipeline';
import { SettingMultiReimbursements } from '../interfaces/Settings';

type ReimbursementState = {
    reimbursements: Pipeline[];
    simpleReimbursements: SimplePipeline[];
    multiReimbursements: SettingMultiReimbursements[];
    selectMultiReimbursement: SettingMultiReimbursements;
    remainingLimitMonth: {idr: number, usd: number};
    remainingLimitYear: {idr: number, usd: number};
    setRemainingLimitMonth: (remainingLimitMonth: {idr: number, usd: number}) => void;
    setRemainingLimitYear: (remainingLimitYear: {idr: number, usd: number}) => void;
    setReimbursements: (reimbursements: Pipeline[]) => void;
    setSimpleReimbursements: (simpleReimbursements: SimplePipeline[]) => void;
    setMultiReimbursements: (multiReimbursements: SettingMultiReimbursements[]) => void;
    setSelectMultiReimbursement: (selectMultiReimbursement: SettingMultiReimbursements) => void;
}

export const useReimbursementStore = create<ReimbursementState>((set, getState) => ({
     remainingLimitMonth: {idr: 0, usd: 0},
    remainingLimitYear: {idr: 0, usd: 0},
    reimbursements: [],
    simpleReimbursements: [],
    pipelineLoading: false,
    simplePipelineLoading: false,
    multiReimbursements: [],
    selectMultiReimbursement: {} as SettingMultiReimbursements,
    preventPipelineFetch: false,

    setReimbursements: (reimbursements) => {
        set({ reimbursements });
    },
    setSimpleReimbursements: (simpleReimbursements) => {
        set({ simpleReimbursements });
    },
    setMultiReimbursements: (multiReimbursements) => {
        set({ multiReimbursements });
    },
    setSelectMultiReimbursement: (selectMultiReimbursement) => {
        set({ selectMultiReimbursement });
    },
    setRemainingLimitMonth: (remainingLimitMonth) => {
        set({ remainingLimitMonth });
    }, 
    setRemainingLimitYear: (remainingLimitYear) => {
        set({ remainingLimitYear });
    },
}));